import { createSlice } from '@reduxjs/toolkit'
import { sports as initialSportsData } from '../../pages/SportPage/sports'

export interface Team {
	name: string
	pt_name: string
	odds: number
}

export interface Game {
	id: number
	start_time: string
	home: Team
	away: Team
	draw?: number
}

export interface League {
	league_name: string
	pt_name: string
	games: Game[]
}

export interface Sport {
	sport_id: string
	name: string
	pt_name: string
	sport_icon: string
	leagues: League[]
}

interface SportsState {
	sports: Sport[]
	activeSport: Sport | null
}

const initialState: SportsState = {
	sports: initialSportsData,
	activeSport: initialSportsData?.[0] ?? null,
}

export const sportsSlice = createSlice({
	name: 'sports',
	initialState,
	reducers: {
		setActiveSport: (state, action) => {
			state.activeSport = action.payload
		},
	},
})

export const { setActiveSport } = sportsSlice.actions
export default sportsSlice.reducer
